import TreeView from './TreeView.container';

export default TreeView;
